import { gaPushEvent, mixpanelSetUserProperties } from "../base.analytics";
import { shareAttributionProps } from "../shareAttribution";
import {
  gaEventShortUrlConverted,
  gaEventShortUrlFollowed,
} from "./onboarding.analytics";

enum Event {
  AUTH_LOGIN = "login",
  AUTH_SIGNUP = "sign_up",
  VIEW_SIGN_UP = "view_sign_up",
  START_SIGN_UP = "start_sign_up",
  VIEW_ONBOARDING = "view_onboarding",
  COMPLETE_ONBOARDING = "complete_onboarding",
}

export function gaEventAuthLogin(
  userUid: string,
  accountType?: "email" | "google" | "apple"
) {
  gaPushEvent(Event.AUTH_LOGIN, {
    account_type: accountType,
    user: {
      account_id: userUid,
    },
  });
}

export function gaEventAuthSignup(
  userUid: string,
  accountCreationType: "email" | "google" | "apple"
) {
  gaPushEvent(Event.AUTH_SIGNUP, {
    user: {
      account_id: userUid,
      account_creation_type: accountCreationType,
    },
    // TODO: Check missing lead_profile field.
  });
}

export function gaEventViewSignUp() {
  gaPushEvent(Event.VIEW_SIGN_UP);
}

export function gaEventStartSignUp(params?: {
  origin?: string;
  account_type?: "email" | "google" | "apple";
}) {
  gaPushEvent(Event.START_SIGN_UP, {
    origin: params?.origin,
    account_type: params?.account_type,
    ...shareAttributionProps(),
  });
}

export function gaEventViewOnboarding() {
  gaPushEvent(Event.VIEW_ONBOARDING);
  gaEventShortUrlFollowed();
}

/**
 * `account` says whether the caller knows the account was just created. Only a
 * new account is a referred sign-up: the OAuth room callback fires this event
 * for existing members too, and must not spend a share credit on them.
 */
export function gaEventCompleteOnboarding(
  userUid: string,
  defaultRoomId: string | null,
  account: "new" | "maybe_existing"
) {
  const attribution =
    account === "new"
      ? shareAttributionProps()
      : {
          referral_channel: null,
          referrer_user_id: null,
          referrer_landing_path: null,
        };
  gaPushEvent(
    Event.COMPLETE_ONBOARDING,
    defaultRoomId !== null
      ? {
          environment: { room_id: defaultRoomId },
          user: {
            account_id: userUid,
          },
          ...attribution,
        }
      : {
          user: {
            account_id: userUid,
          },
          ...attribution,
        }
  );
  // On the profile too, so a cohort of referred members can be followed past
  // the sign-up event (retention, their own shares: the next generation).
  if (attribution.referral_channel !== null) {
    mixpanelSetUserProperties({
      referral_channel: attribution.referral_channel,
      referrer_user_id: attribution.referrer_user_id,
    });
  }
  gaEventShortUrlConverted();
}
